<div class="blade-wrapper">
  <div class="blade-header">
    <div *ngIf="!$hasMissingRequiredInParams" class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized && !$hasMissingRequiredInParams">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-name" *ngIf="!fields.name.hidden && !fields.name.removed" 
                            class="field-container double {{fields.name.invalid ? 'invalid' : ''}} {{fields.name.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.name.styles.style"
                            [ngClass]="fields.name.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.name.label + (fields.name.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.name.label}}<span *ngIf="fields.name.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="name"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.name.control.readOnly || fields.name.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.name.control.placeholder}}"
                                [ngStyle]="fields.name.control.styles.style"
                                [ngClass]="fields.name.control.styles.classes"
                                [matTooltip]="fields.name.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.name.invalid">
                          <ng-container *ngFor="let error of fields.name.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-short_name" *ngIf="!fields.short_name.hidden && !fields.short_name.removed" 
                            class="field-container full {{fields.short_name.invalid ? 'invalid' : ''}} {{fields.short_name.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.short_name.styles.style"
                            [ngClass]="fields.short_name.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.short_name.label + (fields.short_name.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.short_name.label}}<span *ngIf="fields.short_name.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="short_name"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.short_name.control.readOnly || fields.short_name.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.short_name.control.placeholder}}"
                                [ngStyle]="fields.short_name.control.styles.style"
                                [ngClass]="fields.short_name.control.styles.classes"
                                [matTooltip]="fields.short_name.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.short_name.invalid">
                          <ng-container *ngFor="let error of fields.short_name.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-area" *ngIf="!fields.area.hidden && !fields.area.removed" 
                            class="field-container double {{fields.area.invalid ? 'invalid' : ''}} {{fields.area.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.area.styles.style"
                            [ngClass]="fields.area.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.area.label + (fields.area.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.area.label}}<span *ngIf="fields.area.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <DockAppointments-areas_dd_single 
                            data-cy="selector"
                            [type]="fields.area.control.type"
                            formControlName="area"
                            (displayTextChange)="fields.area.control.displayText=$event"
                            [placeholder]="fields.area.control.placeholder"
                            [styles]="fields.area.control.styles"
                            [tooltip]="fields.area.control.tooltip"
                          [warehouseIds]="$fields_area_selector_inParams_warehouseIds"
                        >
                        </DockAppointments-areas_dd_single>
                        <ng-container *ngIf="fields.area.invalid">
                          <ng-container *ngFor="let error of fields.area.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-inbound_only" *ngIf="!fields.inbound_only.hidden && !fields.inbound_only.removed" 
                            class="field-container double {{fields.inbound_only.invalid ? 'invalid' : ''}} {{fields.inbound_only.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.inbound_only.styles.style"
                            [ngClass]="fields.inbound_only.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.inbound_only.label + (fields.inbound_only.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.inbound_only.label}}<span *ngIf="fields.inbound_only.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="inbound_only"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.inbound_only.control.styles.style"
                                      [ngClass]="fields.inbound_only.control.styles.classes"
                                      [matTooltip]="fields.inbound_only.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.inbound_only.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.inbound_only.invalid">
                          <ng-container *ngFor="let error of fields.inbound_only.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-outbound_only" *ngIf="!fields.outbound_only.hidden && !fields.outbound_only.removed" 
                            class="field-container double {{fields.outbound_only.invalid ? 'invalid' : ''}} {{fields.outbound_only.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.outbound_only.styles.style"
                            [ngClass]="fields.outbound_only.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.outbound_only.label + (fields.outbound_only.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.outbound_only.label}}<span *ngIf="fields.outbound_only.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="outbound_only"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.outbound_only.control.styles.style"
                                      [ngClass]="fields.outbound_only.control.styles.classes"
                                      [matTooltip]="fields.outbound_only.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.outbound_only.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.outbound_only.invalid">
                          <ng-container *ngFor="let error of fields.outbound_only.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

      <div *ngIf="$hasMissingRequiredInParams" class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>